<iframe
        [ngClass]="'machine-iframe'"
        [src]='getRdpUrl()'
        [style.pointerEvents]="pointerEvents"
        #machineIFrame></iframe>
